import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { ILeanBrandTile } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/ILeanBrandTileAdapters";
import { PageLoadEvent } from "@faire/retailer-visitor-shared/services/performance/const";
import { PerformanceMarker } from "@faire/retailer-visitor-shared/services/performance/PerformanceMarker";
import { ProductCacheStore } from "@faire/retailer-visitor-shared/stores/domain/ProductCacheStore";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
export var fetchBrandFirstResults = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(request, param, strictLocalize) {
        var signal, response;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    signal = param.signal;
                    PerformanceMarker.get().mark(PageLoadEvent.primaryFetchStart);
                    return [
                        4,
                        ProductCacheStore.get().brandSearch(request, {
                            signal: signal
                        })
                    ];
                case 1:
                    response = _state.sent();
                    PerformanceMarker.get().mark(PageLoadEvent.primaryFetchEnd);
                    return [
                        2,
                        {
                            brands: response.brands.map(ILeanBrandTile.fromSearchV2IBrand(strictLocalize)).filter(isNotUndefined),
                            formatted_total_primary_results_count: response.formatted_total_primary_results_count,
                            visual_filter_options: response.visual_filter_options,
                            pagination_data: response.pagination_data,
                            request_id: response.request_id,
                            filter_sections: response.filter_sections,
                            product_tiles: undefined,
                            retrieval_queries: [],
                            brand_page_query_params: undefined,
                            brand_page_query_parameters: undefined,
                            related_search_terms: [],
                            more_in_c3: undefined
                        }
                    ];
            }
        });
    });
    return function fetchBrandFirstResults(request, _, strictLocalize) {
        return _ref.apply(this, arguments);
    };
}();
